(function() {
  var AdminApp, GrowerApp, PortalApp, Router,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  GrowerApp = require('resources/assets/coffee/Grower/GrowerApp').GrowerApp;

  PortalApp = require('resources/assets/coffee/Portal/PortalApp').PortalApp;

  AdminApp = require('resources/assets/coffee/Admin/AdminApp').AdminApp;

  exports.MainRouter = (function(superClass) {
    extend(MainRouter, superClass);

    function MainRouter() {
      this.registerRoutes = bind(this.registerRoutes, this);
      return MainRouter.__super__.constructor.apply(this, arguments);
    }

    MainRouter.prototype.prefix = 'Main';

    MainRouter.prototype.module_name = 'MainRouter';

    MainRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('core::Angular/SetPasswordService', ['$http']);
      this.controller('core::Angular/DefaultController', ['$scope', '$state', '$window', '$stateParams', 'Core.Services.Session', 'Core.Services.Routing']);
      this.controller('core::Angular/LoginController', ['$scope', '$transitions', '$state', '$uibModal', '$http', '$q', '$stateParams', 'Core.Services.Routing', 'Core.Services.Session']);
      this.controller('core::Angular/ForgotPasswordController', ['$scope', '$transitions', '$uibModalInstance', '$http', '$location']);
      this.controller('core::Angular/SetPasswordController', ['$scope', '$transitions', '$state', '$stateParams', '$http', '$q', 'Main.Services.SetPasswordService', 'AuthResponse', 'Core.Services.Routing', 'Core.Services.Session']);
      return this.controller('core::Angular/EmailUnsubscribeController', ['$scope', '$http']);
    };

    MainRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('default', {
        url: '/?b?r',
        views: {
          main: {
            template: '<div></div>',
            controller: 'Main.Controllers.DefaultController'
          }
        }
      }).state('login', {
        url: '/login?pending_email?b?r?reset_email',
        params: {
          registration_token: null,
          external_system_name: null,
          reset_email: null
        },
        views: {
          main: {
            templateUrl: 'backend/login',
            controller: 'Main.Controllers.LoginController'
          }
        }
      }).state('logout', {
        url: '/logout?pending_email?b',
        views: {
          main: {
            template: '<div></div>',
            controller: [
              '$state', 'Core.Services.Session', '$stateParams', (function(_this) {
                return function($state, session, $stateParams) {
                  session.remove('Authorization');
                  session.remove('OriginalUser');
                  session.remove('AuthTime');
                  session.remove('SelectedCompany-grower');
                  session.remove('SelectedCompany-portal');
                  session.remove('SelectedCompany-admin');
                  if (typeof Raven !== "undefined" && Raven !== null) {
                    Raven.setUserContext();
                  }
                  return $state.go('login', $stateParams);
                };
              })(this)
            ]
          }
        }
      }).state('set-password', {
        url: '/set-password?authentication_code&data_token&is_password_reset',
        views: {
          main: {
            templateUrl: 'backend/session-mgmt/set-password-layout',
            controller: 'Main.Controllers.SetPasswordController'
          }
        },
        resolve: {
          AuthResponse: [
            'Main.Services.SetPasswordService', '$stateParams', (function(_this) {
              return function(repository, $stateParams) {
                return repository.checkAuthCode($stateParams);
              };
            })(this)
          ]
        }
      }).state('unsubscribe', {
        url: '/unsubscribe/:token',
        views: {
          main: {
            controller: 'Main.Controllers.EmailUnsubscribeController',
            templateUrl: function($stateParams) {
              return 'backend/grower/unsubscribe/from-email/' + $stateParams.token;
            }
          }
        }
      }).state('grower', {
        url: '/grower',
        views: {
          main: {
            templateUrl: 'backend/grower/home/index',
            controller: [
              '$scope', '$state', '$timeout', function($scope, $state, $timeout) {
                if ((window.App != null) && window.App instanceof GrowerApp) {
                  console.error("The grower app is being reloaded! This screws with the map. Don't do this! If you are using { reload: true }, change it to { reload: 'grower.my.state' } instead.");
                }
                window.App = new GrowerApp();
                App.boot();
                if ($state.current.name === 'grower') {
                  return $timeout((function(_this) {
                    return function() {
                      return angular.element('#nav_primary_links li:first-child a').first().trigger('click');
                    };
                  })(this));
                }
              }
            ]
          }
        }
      }).state('portal', {
        url: '/portal',
        views: {
          main: {
            templateUrl: 'backend/portal/home/index',
            controller: [
              '$scope', '$state', '$timeout', function($scope, $state, $timeout) {
                if ((window.App != null) && window.App instanceof PortalApp) {
                  console.error("The portal app is being reloaded! This screws with the map. Don't do this! If you are using { reload: true }, change it to { reload: 'portal.my.state' } instead.");
                }
                window.App = new PortalApp();
                App.boot();
                if ($state.current.name === 'portal') {
                  return $timeout((function(_this) {
                    return function() {
                      return angular.element('#nav_primary_links > li:first-child a').first().trigger('click');
                    };
                  })(this));
                }
              }
            ]
          }
        }
      }).state('admin', {
        url: '/admin',
        views: {
          main: {
            templateUrl: 'backend/admin/home/index',
            controller: [
              '$scope', '$state', '$timeout', function($scope, $state, $timeout) {
                window.App = new AdminApp();
                App.boot();
                if ($state.current.name === 'admin') {
                  return $timeout((function(_this) {
                    return function() {
                      return angular.element('#nav_primary_links li:first-child a').first().trigger('click');
                    };
                  })(this));
                }
              }
            ]
          }
        }
      }).state('dashboard', {
        url: '/dashboard',
        views: {
          main: {
            templateUrl: 'backend/dashboard-page',
            controller: 'DashboardController'
          }
        }
      }).state('api-data-forward', {
        url: '/forward?token',
        views: {
          main: {
            template: '<div></div>',
            controller: 'ApiDataForwardingController'
          }
        }
      });
    };

    return MainRouter;

  })(Router);

}).call(this);
